import { memo } from 'react';
import type { KeyDocumentType } from '@trinity/chat';
import type { FileIconProps } from './interfaces';
import { getIconByExtension, IconByFileType } from './utils';

type Props = {
  extension: string;
  /** Key documents (`workspace.files.file_type`) get their own icon regardless of extension */
  fileType?: KeyDocumentType | null;
} & FileIconProps;

export const FileIcon = memo(({ extension, fileType, size = 28, ...iconProps }: Props) => {
  const Icon = (fileType && IconByFileType[fileType]) || getIconByExtension(extension);

  return <Icon size={size} {...iconProps} />;
});
